import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=2fea6857&scoped=true&lang=html&"
import script from "./Services.vue?vue&type=script&lang=js&"
export * from "./Services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea6857",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/mayo/workspace/sangeetham/local/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VImg,VLayout,VProgressCircular})
